import * as Long from "long";
import { IdResource } from "../../../../constants/IdResource";
import { selectAndApplyActiveBuildingBuffedCost } from "../../../../selectors/selectBuffsInfo";
import { selectBuildingUpgradeInfo } from "../../../../selectors/selectExistingBuildingInfo";
export var checkBuildingUpgradeHasEnoughResourcePremium = function (path) { return function (action, state$) {
    var state = state$.value;
    if (action.premium) {
        var upgradeInfo = selectBuildingUpgradeInfo(action.building);
        var next = upgradeInfo.nextStage;
        var premiumCost = next.premium.cost.find(function (cost) { return cost.resourceId === IdResource.Gold; });
        var playerGold = state.inventoryInfo.resource.find(function (resource) { return resource.typeId === IdResource.Gold; });
        var availableGold = playerGold && playerGold.amount ? playerGold.amount : Long.ZERO;
        if (!premiumCost) {
            return undefined;
        }
        var goldAmount = selectAndApplyActiveBuildingBuffedCost(state, action.building.balancing.id, IdResource.Gold, premiumCost.amount);
        if (availableGold.lessThan(Long.fromValue(goldAmount))) {
            return path;
        }
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkBuildingUpgradeHasEnoughResourcePremium.ts
// module id = 2073
// module chunks = 3